export default "__VITE_ASSET__7eb3cc73__"